import { Sprite, Texture } from 'pixi.js';
import { VideoBgOptions } from '../../../../elements/resource/types/shape.type';
import { BackgroundService } from '../../../store/studio/background/background.service';
import {
  CanvasBackground,
  CanvasBackgroundConfig,
} from '../../canvas-background';
import gsap from 'gsap';
import { _screenX, _screenY } from '../../../../services/canvas/canvas.service';
export class VideoBackground extends CanvasBackground {
  constructor(
    bgService: BackgroundService,
    private readonly options: VideoBgOptions,

    config: CanvasBackgroundConfig = {},
  ) {
    super(bgService, config);
    this.init(config.thumbnail);
  }

  _animate(start: number) {
    // console.log('------ video-background > _animate -------', start);
    const timeline = gsap.timeline();
    timeline.add(
      gsap.to(
        { value: 0 },
        {
          value: 1,
          duration: 1,
          ease: 'none',
        },
      ),
      0,
    );
    timeline.eventCallback('onStart', () => {
      console.log('video --------------, on-start');
      this.addToCanvas();
      this.video?.play();
    });
    return timeline;
  }

  video: HTMLVideoElement;
  sprite: Sprite;

  play() {
    this.video?.play();
  }
  init(thumbnail = false) {
    const { url } = this.options;
    // super.init();
    // -- // -- // -- // -- // -- //
    // -- // -- // -- // -- // -- //
    // -- // -- // -- // -- // -- //

    this.video = document.createElement('video');
    this.video.crossOrigin = 'anonymous';

    this.video.src = url;
    // this.video.autoplay = true;
    // this.video.loop = true;
    this.video.muted = true; // usually required for autoplay
    this.video.playsInline = true;

    // this.video.loop = true;
    // this.video.autoplay = true;

    this.video.addEventListener('canplay', () => {
      // console.log('canplay', this.video.duration);
      const texture = Texture.from(this.video, {
        resourceOptions: {
          crossorigin: 'anonymous', // important if not same-origin
          autoPlay: false, // don't start automatically
          preload: 'auto', // hint the browser
          updateFPS: 30, // how often to copy frames to the GPU
        },
      });

      // 3. Make a sprite
      this.sprite = new Sprite(texture);
      this.fitVideo(this.video, this.sprite);

      this.video.play();
      if (thumbnail) {
        this.captureThumbnailAt(url, 0).then(blob => {
          const objectUrl = URL.createObjectURL(blob);
          const thumbTexture = Texture.from(objectUrl);
          this.sprite.texture = thumbTexture;
        });
        // this.container.addChildAt(this.sprite, 0);
        return;
      }
      // this.container.addChildAt(this.sprite, 0);
      // resolve();
    });
  }

  addToCanvas(): void {
    super.addToCanvas();
    this.container.addChildAt(this.sprite, 0);
  }

  fitVideo(video: HTMLVideoElement, sprite: Sprite) {
    const canvasWidth = _screenX;
    const canvasHeight = _screenY;

    const videoWidth = video.videoWidth;
    const videoHeight = video.videoHeight;

    // COVER (fill canvas, may crop)
    const scaleCover = Math.max(
      canvasWidth / videoWidth,
      canvasHeight / videoHeight,
    );

    // If you prefer CONTAIN (show all, may letterbox), use:
    // const scaleContain = Math.min(
    //   canvasWidth / videoWidth,
    //   canvasHeight / videoHeight,
    // );

    const scale = scaleCover; // or scaleContain

    sprite.width = videoWidth * scale;
    sprite.height = videoHeight * scale;

    // Center it
    sprite.x = (canvasWidth - sprite.width) / 2;
    sprite.y = (canvasHeight - sprite.height) / 2;
  }

  async captureThumbnailAt(videoUrl: string, timeSec: number): Promise<Blob> {
    const v = document.createElement('video');
    v.crossOrigin = 'anonymous';
    v.preload = 'auto';
    v.muted = true; // avoid autoplay issues on some browsers
    v.playsInline = true;
    v.src = videoUrl;

    await this.once(v, 'loadedmetadata');

    // Clamp within duration
    const t = Math.min(Math.max(timeSec, 0), v.duration || timeSec);
    v.currentTime = t;

    await this.once(v, 'seeked');

    const w = v.videoWidth;
    const h = v.videoHeight;
    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d')!;
    ctx.drawImage(v, 0, 0, w, h);

    // Get a Blob (better than dataURL)
    return await new Promise<Blob>(resolve =>
      canvas.toBlob(b => resolve(b!), 'image/jpeg', 0.9),
    );
  }

  once(target: EventTarget, type: string) {
    return new Promise<void>((resolve, reject) => {
      const onOk = () => {
        cleanup();
        resolve();
      };
      const onErr = () => {
        cleanup();
        reject(new Error(type + ' failed'));
      };
      const cleanup = () => {
        target.removeEventListener(type, onOk);
        target.removeEventListener('error', onErr);
      };
      target.addEventListener(type, onOk, { once: true });
      target.addEventListener('error', onErr, { once: true });
    });
  }
}
